import React from "react";
import { Box, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { sliderClasses } from "@mui/material/Slider";

import MzTooltip from "@markaaz/ui/MzTooltip";
import MzSlider from "@markaaz/ui/MzSlider";
import { valueLabelFormat } from "../decisioning/slider";

const sxRow = {
  root: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: "15px",
    height: "118px",
    maxWidth: "860px",
    color: "darkBlue.c100",
    background: "white",
    borderRadius: "8px"
  },
  label: {
    fontWeight: 600,
    paddingLeft: "40px"
  },
  icon: {
    color: "lightBlue.c100"
  },
  slider: {
    [`&.${sliderClasses.root}`]: {
      width: "402px",
      marginRight: "40px"
    },
    [`.${sliderClasses.rail}`]: {
      background: (theme) => theme.palette.common.gradientRisk2
    }
  }
};

export default function MatchingRow({ rowData, values = {}, onSliderChange }) {
  const label = rowData.label;
  const [value, setValue] = React.useState([values.lowerThreshold, values.upperThreshold]);
  const classes = [sxRow.root];
  const minDistance = 1;
  const tooltip = (
    <Typography variant="body2">
      {rowData.tooltipContent} <br />
      <br /> {rowData.tooltipContent2}
    </Typography>
  );

  React.useEffect(() => {
    setValue([values.lowerThreshold, values.upperThreshold]);
  }, [values.lowerThreshold, values.upperThreshold]);

  function handleSliderChange(_, value, activeThumb) {
    let newValue = value;
    onSliderChange(_, newValue);
    setValue(newValue);

    if (activeThumb === 0) {
      setValue([Math.min(newValue[0], value[1] - minDistance), value[1]]);
    } else {
      setValue([value[0], Math.max(newValue[1], value[0] + minDistance)]);
    }
  }

  return (
    <Box sx={classes}>
      <Typography variant="body2" sx={sxRow.label}>
        {label}
      </Typography>
      <Box flexGrow={1}></Box>
      <MzSlider
        value={value}
        onChange={handleSliderChange}
        min={rowData.slider.min}
        max={rowData.slider.max}
        marks={rowData.slider.marks}
        scale={rowData.slider.scale}
        valueLabelFormat={rowData.slider.valueLabelFormat && valueLabelFormat(rowData.slider.valueLabelFormat)}
        track={rowData.slider.track}
        sx={sxRow.slider}
        variant={rowData.slider.variant}
      />

      <MzTooltip
        title={tooltip}
        arrow
        PopperProps={{
          modifiers: [{ name: "preventOverflow", options: { padding: 20 } }]
        }}
      >
        <InfoOutlinedIcon sx={sxRow.icon}></InfoOutlinedIcon>
      </MzTooltip>
    </Box>
  );
}
